class VipTiers {
	constructor(vipTiers, currentStatusLabel, benefitHeaders, benefitHeadersTitle, benefitsList, customer) {
		this.vipTiers = vipTiers;
		this.currentStatusLabel = currentStatusLabel;
		this.benefitHeaders = benefitHeaders;
		this.benefitHeadersTitle = benefitHeadersTitle;
		this.benefitsList = benefitsList;
		this.customer = customer;
	}


	renderVipTiers() {
		
		console.log("renderVipTiers() works")
		$(".loyalty-vip-tiers-container").append(
			$("<div>").addClass("loyalty-slick-nav-container"),
			$("<div>").addClass("loyalty-benefit-headers").append(
			
				$("<div>").addClass("loyalty-benefit-headers-list-item").addClass("loyalty-benefit-list-header").text(this.benefitHeadersTitle)
				),
				$("<div>").addClass("loyalty-benefit-list")
			);
			//headers column
			this.benefitHeaders.forEach(header => {
				$(".loyalty-benefit-headers").append(
					$("<div>").addClass("loyalty-benefit-headers-list-item").text(header)
					)
			});

			// creates the 4 columns - one for each tier
			this.benefitsList.forEach(benefit => {
				$(".loyalty-benefit-list").append(
					$("<div>", {
						class: `loyalty-vip-tier-item-${benefit.tierId}`
					}).addClass("loyalty-vip-tier").append(
					$("<div>").addClass("loyalty-vip-tier-header-container").append(
						$("<div>").addClass("loyalty-vip-tier-status-container").append(
						$("<div>").addClass("loyalty-vip-tier-current-status-container"),
						$("<div>").addClass("loyalty-vip-tier-next-requirement-container")

						),
						$("<div>").addClass("loyalty-vip-tier-benefit-item").addClass("loyalty-vip-tier-name").text(this.getVipTierName(benefit.tierId)),
						$("<div>").addClass("loyalty-vip-tier-requirement").text(benefit.tierRequirement)
					)
					)
					);
				benefit.benefits.forEach(item => {
					$(`.loyalty-vip-tier-item-${benefit.tierId}`).append(
						$("<div>").addClass("loyalty-vip-tier-benefit-item").text(item)
						)

				})

			})
			this.makeSlick();
			this.renderCurrentStatus();
			this.renderNextTierRequirnemts();
            this.renderBenefitStyling()
		
			
	}


	getVipTierName(id) {
		return this.vipTiers[this.vipTiers.map(tier => tier.id).indexOf(id)].name
	}

	getVipTierDivLocation() {
		return this.vipTiers.map(tier => tier.name).indexOf(this.customer.vipTier.name) + 1
	}

	renderCurrentStatus() {
		
		if (this.customer.created_at !== undefined) {
			$(`.loyalty-benefit-list .loyalty-vip-tier:nth-of-type(${this.getVipTierDivLocation()}) .loyalty-vip-tier-current-status-container`).text(this.currentStatusLabel);
			$(`.loyalty-vip-tier:nth-of-type(${this.getVipTierDivLocation()})`).addClass("loyalty-current-status-bg")
		}
	}

	getNextTierName() {

		let nextTierName = '';
		let tierNames = this.vipTiers.map(tier => tier.name);
			let currentTierIndex = tierNames.indexOf(this.customer.vipTier.name);
			if (currentTierIndex < tierNames.length - 1) {
				nextTierName = this.vipTiers[tierNames.indexOf(this.customer.vipTier.name) + 1].name;
			}
		return nextTierName;
		
	}

	renderNextTierRequirnemts() {
		if (this.customer.created_at !== undefined) {
			let nextTierName = this.getNextTierName();
			let requiredAmountToMoveUpTiers = this.customer.vipTierStatsNeeded.amountSpentCents / 100;
			if (nextTierName  !== '' || requiredAmountToMoveUpTiers !== 0) {
				$(`.loyalty-vip-tier:nth-of-type(${this.getVipTierDivLocation()}) .loyalty-vip-tier-next-requirement-container`).text(`Spend £${requiredAmountToMoveUpTiers} more to earn ${nextTierName}`);
			}
		}
	}


  renderBenefitStyling() {
    $(".loyalty-benefit-headers-list-item:nth-child(3)").append(
      $("<div>").addClass("loyalty-benefit-extra").text("(BE THE FIRST TO SHOP NEW ARRIVALS, SALE + MORE)")
    )
  }

	

	makeSlick() {

		if (Array.from(document.querySelectorAll("script")).filter(script => script.src.includes("slick")).length < 1) {
			var newscript = document.createElement('script');
			     newscript.type = 'text/javascript';
			     newscript.async = true;
			     newscript.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
			  (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild(newscript);
		};
		
		  if ($(window).width() < 800) {
		  setTimeout(function(){
		    $('.loyalty-benefit-list').slick({
		        slidesToShow: 3,
		        slidesToScroll: 1,
		        arrows: false,
		        adaptiveHeight: true,
		        
		        responsive: [
		          {
		          	breakpoint: 769, settings: {slidesToShow: 2, slidesToScroll: 1, dots: true, appendDots: $('.loyalty-slick-nav-container')}
		          }
		       ]});
		    }, 1000);
          }
	}
}